/**
 * Chat do site (Centriu Link) — onde ele pode aparecer, e por quê.
 *
 * Este arquivo existe separado do componente por um motivo só: a regra de
 * quais rotas recebem o chat é uma decisão de PRIVACIDADE, não de layout, e
 * decisão de privacidade merece teste.
 *
 * ┌───────────────────────────────────────────────────────────────────────┐
 * │ O QUE O WIDGET ENVIA — verificado no código dele, não presumido       │
 * │                                                                       │
 * │ Ao enviar uma mensagem, o widget monta `context` com:                 │
 * │   · window.location.href  ← a URL INTEIRA, com query string           │
 * │   · document.referrer                                                 │
 * │   · utm_source / utm_medium / utm_campaign                            │
 * │   · navigator.userAgent                                               │
 * │                                                                       │
 * │ Isso é normal para um chat de site e é inofensivo em /exames.         │
 * │ Em /pedido/<token> é outra história: o token NA URL é o único segredo │
 * │ que dá acesso ao pedido (D-05). Mandá-lo para um terceiro anula a     │
 * │ proteção inteira — e o vazamento seria silencioso, porque nada na     │
 * │ tela indicaria que aconteceu.                                         │
 * │                                                                       │
 * │ Por isso o chat não carrega nessas rotas. Não é excesso de zelo: é a  │
 * │ mesma razão de /pedido/ estar no robots.txt e de a página nascer com  │
 * │ noindex — terceira camada da mesma defesa.                            │
 * └───────────────────────────────────────────────────────────────────────┘
 *
 * O painel administrativo fica de fora por outro motivo: quem atende não é
 * quem compra. Um chat de visitante aberto sobre a tela de pedidos é ruído,
 * e o widget guarda conversa em `localStorage` do navegador — que na recepção
 * é compartilhado entre turnos.
 */

/**
 * Prefixos de rota que NÃO recebem o chat.
 *
 * `/pedido` cobre `/pedido/<token>` e `/pedido/<token>/voucher`, exatamente
 * como a regra do robots.txt. Se alguém mover o comprovante para fora deste
 * prefixo, ESTA LISTA PRECISA MUDAR JUNTO — e o teste ao lado é o que faz o
 * esquecimento aparecer.
 */
export const ROTAS_SEM_CHAT = ['/pedido', '/admin'] as const;

/**
 * O chat pode aparecer nesta rota?
 *
 * Casa por segmento, nunca por texto solto: `/pedidos-especiais` não é
 * `/pedido`. Um `startsWith` ingênuo bloquearia rotas legítimas que só por
 * acaso começam com as mesmas letras.
 */
export function chatPermitido(pathname: string): boolean {
  const caminho = normalizar(pathname);

  return !ROTAS_SEM_CHAT.some(
    (bloqueado) => caminho === bloqueado || caminho.startsWith(`${bloqueado}/`),
  );
}

/**
 * Deixa o caminho comparável: minúsculo, com barra inicial e sem barra final.
 *
 * O roteador entrega o caminho já normalizado, mas esta função também é
 * chamada com valor vindo de fora dele em teste — e uma comparação de
 * privacidade que depende de o chamador ter capricho não é uma defesa.
 */
function normalizar(pathname: string): string {
  const semQuery = pathname.split(/[?#]/)[0] ?? '';
  const comBarra = semQuery.startsWith('/') ? semQuery : `/${semQuery}`;
  const semBarraFinal = comBarra.length > 1 ? comBarra.replace(/\/+$/, '') : comBarra;

  return semBarraFinal.toLowerCase();
}
